import { TourConsumptionRow } from "@shared/types/localTypes/tour.ts";

type SortTourConsumptionRows = (
  rows: ReadonlyArray<TourConsumptionRow>,
) => ReadonlyArray<TourConsumptionRow>;

const sortTourConsumptionRows: SortTourConsumptionRows = (rows) =>
  [...rows].sort(
    (a, b) =>
      b.trafficBytes + b.storageBytes - (a.trafficBytes + a.storageBytes),
  );

export default sortTourConsumptionRows;
